import Select from 'react-select';
import Modal from 'react-modal';
import React, { Component } from 'react';
import { Spinner } from 'react-activity';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? '#2a87d0' : 'none',
        color: state.isFocused ? 'white' : 'black',
        ':hover': {
            backgroundColor: '#2a87d0',
            color: 'white',
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#28235C',
        borderRadius: '8px',
        fontSize: '16px',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'white',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: 'white',
        ':hover': {
            backgroundColor: '#28235C',
            color: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
        },
    }),
};

class FlaggingStatusSession extends Component {
    render() {
        return (
            <Modal
                isOpen={this.props.openModal}
                onRequestClose={this.props.closeModal}
                contentLabel="Example"
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 bg-white rounded-lg">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-semibold text-black">
                                Flagged Session
                            </h3>
                            <button type="button" onClick={() => this.props.closeModal()}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        fill="white"
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        <div className="grid grid-cols-12">
                            <div className="col-span-12 mt-3 sm:col-span-12">
                                <label
                                    htmlFor="select-subcategory"
                                    className="block mb-2 text-base font-normal rounded text-black mt-2 after:content-['*'] after:ml-0.5 after:text-red"
                                >
                                    Select Status
                                </label>
                                <Select
                                    isLoading={this.props.isFlagCategoryLoading}
                                    id="flagStatusId"
                                    name="flagStatusId"
                                    onChange={(event) => {
                                        this.props.onChange(event, 'flagStatusId');
                                    }}
                                    value={this.props.flagStatusId}
                                    ref={(r) => (this.flagStatusRef = r)}
                                    className="block rounded whitespace-nowrap text-secondary text-md border-black-10"
                                    options={this.props.flagStatusList}
                                    styles={customStyles}
                                    placeholder="Select Status"
                                    onKeyDown={(event) => {
                                        const key = event.key;
                                        const allowedCharacters = /^[a-zA-Z0-9\s]+$/;
                                        if (
                                            !allowedCharacters.test(key) ||
                                            (event.keyCode === 32 &&
                                                !this.flagCategoryRef.state.inputValue)
                                        ) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <label
                            htmlFor="select-subcategory"
                            className="block mb-2 text-base font-normal rounded text-black mt-6 after:content-['*'] after:ml-0.5 after:text-red"
                        >
                            Summary
                        </label>
                        <div className="py-1">
                            <textarea
                                id="flagStatusSummary"
                                name="flagStatusSummary"
                                rows="3"
                                onChange={(event) => {
                                    this.props.onChange(event, 'flagStatusSummary');
                                }}
                                value={this.props.flagStatusSummary}
                                placeholder="Summary can be added upto 500 characters"
                                className="block w-full px-2 py-1 text-base rounded border-black-10 placeholder:text-secondary sm:text-lg"
                                maxLength={500}
                            />
                        </div>
                        <div className="flex items-center justify-end pt-6 space-x-2">
                            <button
                                data-modal-hide="defaultModal"
                                className="text-red border-red ring-1 ring-inset ring-red rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => this.props.closeModal()}
                            >
                                Close
                            </button>
                            &nbsp;&nbsp;
                            <button
                                data-modal-hide="defaultModal"
                                className="text-white bg-primary rounded-lg font-semibold text-base w-3/12 py-1.5"
                                onClick={() => {
                                    this.props.submitFlagSession();
                                }}
                                disabled={this.props.flagBtnLoading}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {this.props.flagBtnLoading ? <Spinner color="#FFF" /> : 'Save'}
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default FlaggingStatusSession;
